<template>
  <div class="card__content">
    <div class="details" v-for="(item, index) in items" :key="index">
      <span>{{ item.title }}</span>
      <div class="details__info">
        <div class="details__info-slots">
          <h1 class="headliner">
            <slot :name="`slot${index + 1}`"></slot>
          </h1>
          <a-tooltip v-if="item.tooltip && props.slots?.slot_type_billing === 'Postpago' && item.title.includes('N° total de slots a facturar')">
            <template #title>
              <div>
                <p>
                  Total de slots en el mes: <span>{{ props.slots?.slots_invoice }}</span>
                </p>
                <p>
                  Slots actuales:
                  <span> {{ props.slots?.slots_invoice - props.slots?.slot_deleted }} </span>
                </p>
                <p>
                  Slots eliminados: <span> {{ props.slots?.slot_deleted }}</span>
                </p>
              </div>
            </template>
            <InfoCircleOutlined class="icon" />
          </a-tooltip>
          <a-tooltip v-else-if="item.tooltip && props.slots?.tax && item.title?.includes('Precio por slot')" placement="bottom">
            <template #title>
              En base a este precio, se calcula el IGV como un costo adicional.
            </template>
            <InfoCircleOutlined class="icon" />
          </a-tooltip>
        </div>
      </div>
      <h5 @click="emitSlotEvent" v-if="item.subtitle" :class="`${item.subtitle && 'subtitle'}`">
        {{ item.subtitle }}
      </h5>
      <h5 @click="emitSlotEvent" v-if="item.redirect">Editar número de slots</h5>
    </div>
    <div class="info" v-if="origin === 'Recharge'">
      <a-button type="link" @click="showModal">Ver todos mis pagos</a-button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { ISlots, IItems } from "@/@types/settings/slots";

const props = defineProps<{
  slots: ISlots | undefined;
  items: IItems[];
  origin: "Recharge" | "Slots";
}>();
console.log(props);

const emit = defineEmits(["emitSlotEvent", "paymentModal"]);
const emitSlotEvent = () => {
  emit("emitSlotEvent", "slots");
};

const showModal = () => {
  emit("paymentModal", true);
};
</script>

<style lang="sass" scoped>
h1, h4, p
  margin: 0
h5
  color: $primary
.card
  &__content
    display: flex
    padding: 16px 24px
    border: 1px solid $gray-5
    border-radius: 8px
    height: fit-content
    margin-bottom: 10px
    justify-content: space-between
    span
        display: block
        font-size: 14px
        font-weight: 400
        color: $gray-7

    .headliner
        font-size: 20px
        line-height: 34px
        font-weight: 600
        color: $gray-8
    .details
      .subtitle
        font-size: $font-small
        font-weight: 400
        color: $gray-7
        &__info
            display: flex
            gap: 15px
            width: 100%
            justify-items: center
            justify-self: center
            align-items: center
            .icon
              font-size: 17.5px
    .info
      button
        width: 110px
        font-size: 12px
        word-break: break-all
        white-space: normal
        word-wrap: break-word
        border: 1px solid $primary
        height: -webkit-fill-available
</style>
<style>
.details__info-slots {
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
